import { motion } from "framer-motion";

export default function SectionHead({ eyebrow, title, testId }) {
  return (
    <div className="mb-14 sm:mb-20">
      <motion.p
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
        className="text-xs uppercase tracking-[0.4em] text-turq mb-5"
      >
        {eyebrow}
      </motion.p>
      <motion.h2
        data-testid={testId}
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
        className="font-syne font-bold text-3xl sm:text-4xl lg:text-6xl leading-tight max-w-4xl"
      >
        {title}
      </motion.h2>
    </div>
  );
}
